import { ChevronRight } from 'lucide-react';

/** The ▸ / ▾ on a conversation message. Points right when collapsed, down when open. */
export function MessageCollapseToggle({
  expanded,
  onToggle,
  label,
}: {
  expanded: boolean;
  onToggle: () => void;
  /** Who wrote it — read out by screen readers ("Show message from …"). */
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      className="shrink-0 w-5 h-5 -ml-1 inline-flex items-center justify-center rounded text-muted hover:text-fg hover:bg-row-odd"
      aria-expanded={expanded}
      aria-label={`${expanded ? 'Hide' : 'Show'} message from ${label}`}
      title={expanded ? 'Collapse' : 'Expand'}
    >
      <ChevronRight className={`w-4 h-4 transition-transform ${expanded ? 'rotate-90' : ''}`} />
    </button>
  );
}

/** The one line a collapsed message shows in place of its body. */
export function MessagePreviewLine({ text, attachmentCount }: { text: string; attachmentCount?: number }) {
  return (
    <p className="text-sm text-muted truncate">
      {text || <span className="italic">(no text)</span>}
      {attachmentCount ? (
        <span className="ml-2 text-xs">· {attachmentCount} attachment{attachmentCount !== 1 ? 's' : ''}</span>
      ) : null}
    </p>
  );
}

/** "Expand all · Collapse all" for a conversation header. */
export function ExpandCollapseAll({ onExpand, onCollapse }: { onExpand: () => void; onCollapse: () => void }) {
  return (
    <span className="text-xs text-muted">
      <button type="button" className="text-primary hover:underline" onClick={onExpand}>Expand all</button>
      {' · '}
      <button type="button" className="text-primary hover:underline" onClick={onCollapse}>Collapse all</button>
    </span>
  );
}
